import { stringifyQueryString as query} from 'external/react'
import {get, post} from 'external/axios';

export class AdminService {
	 
	async searchClients(id: string, clientSearchParams: any) {
		const url = `/admin/search-clients?${query({id, ...clientSearchParams})}`
		return get(url)
	}

	async clientPurchases(id: string, clientId: string) {
		const url = `/admin/client-purchases?${query({id, clientId})}`
		return get(url)
	}

	async getStripeInfo(id: string, clientId: string) {
		const url = `/admin/get-stripe-info?${query({id, clientId})}`
		return get(url)
	}


	async fetchCoursesInfo(id: string) {
		const url = `/admin/courses-info?${query({id})}`
		return get(url)
	}

	async updateClientCourse(id: string, params: any) {
		return post(`/admin/update-client-course?${query({id})}`, params)
	}

}

export const adminService = new AdminService();